import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";

import { updateReloadYard } from "../../../graphql/mutations";

import { useCreateSuggestionContext, useNotify } from "react-admin";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from "@material-ui/core";

import { logError } from "../../../utils/appUtils";

export const CreateCategory = ({ setCategoryOptions, ...props }) => {
  const notify = useNotify();
  const { filter, onCancel, onCreate } = useCreateSuggestionContext();
  const [value, setValue] = React.useState(filter || "");
  const [error, setError] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      setError(false);
      debugger;

      const newCategory = { key: value.toLowerCase(), name: value };
      const isDuplicate = window.appUser?.reloadYard?.fileCategories?.some(
        (itm) => itm.key === newCategory.key
      );

      if (isDuplicate) {
        setError("Duplicate entry.");
      } else if (window.appUser?.reloadYard) {
        let newCategories = undefined;
        if (window.appUser.reloadYard.fileCategories)
          newCategories = [
            ...window.appUser.reloadYard.fileCategories,
            newCategory,
          ];
        else newCategories = [newCategory];

        await API.graphql(
          graphqlOperation(updateReloadYard, {
            input: {
              id: window.appUser?.reloadYardId,
              active: window.appUser.reloadYard.active,
              name: window.appUser.reloadYard.name,
              fileCategories: newCategories,
            },
          })
        );

        window.appUser.reloadYard.fileCategories = newCategories;
        setCategoryOptions(newCategories);
        setValue("");
        onCreate(newCategory);
      }
    } catch (err) {
      logError("documents:CreateCategory:handleSubmit", err, notify);
    }
  };

  return (
    <Dialog open onClose={onCancel}>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            label="New category name"
            variant="outlined"
            margin="dense"
            value={value}
            onChange={(event) => setValue(event.target.value)}
            autoFocus
            error={error ? true : false}
            helperText={error}
          />
        </DialogContent>
        <DialogActions>
          <Button type="submit">Save</Button>
          <Button onClick={onCancel}>Cancel</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
